import { apiAsync } from '../../../../common/helpers'

export const getPostingsLocations = async ({
  searchText,
  sortOptions,
  filterOptions,
  pageNumber,
  pageSize,
  companyId,
  filters
}) => {
  const response = await apiAsync({
    api: `external/companies/${companyId}/locations`,
    params: {
      pageNumber,
      pageSize,
      search: searchText,
      sortOrder: sortOptions.direction,
      sort: sortOptions.field,
      filterStates: filters.state ? filters.state.locale.state : '',
      filterPosters: filterOptions.cityCountyPoster ? filterOptions.cityCountyPoster.filter : '',
      includePosters: true,
      products: 'postings',
      includeLocaleFacets: true,
      excludeWageOrders: true
    },
    method: 'GET'
  })

  return response.data
}

export const getLocaleFacets = async ({ companyId }) => {
  const response = await apiAsync({
    api: `external/companies/${companyId}/locations`,
    params: {
      products: 'postings',
      includeLocaleFacets: 'true',
      pageSize: 1, // we don't actually need any locations just the facet for country~state
      pageNumber: 1
    },
    method: 'GET'
  })

  return response.data && response.data.localeFacets
}

export const generateUpdateServiceCSV = async ({
  searchText,
  sortOptions,
  filterOptions,
  companyId,
  filters
}) => {
  const params = {
    searchText: (searchText) || '',
    sortDirection: sortOptions ? sortOptions.direction : '',
    sortField: sortOptions ? sortOptions.field : '',
    stateCodeFilter: filters.state ? filters.state.locale.state : '',
    filterPosters: filterOptions.cityCountyPoster ? filterOptions.cityCountyPoster.filter : '',
    product: 'postings',
    excludeWageOrders: true
  }

  const api = `external/companies/${companyId}/locations/export`

  return apiAsync({
    api,
    params,
    method: 'GET'
  })
}

export const generateSubscriptionAuditCSV = async ({
  searchText,
  sortOptions,
  filterOptions,
  companyId,
  filters
}) => {
  const params = {
    searchText: (searchText) || '',
    sortDirection: sortOptions ? sortOptions.direction : '',
    sortField: sortOptions ? sortOptions.field : '',
    stateCodeFilter: filters.state ? filters.state.locale.state : '',
    filterPosters: filterOptions.cityCountyPoster ? filterOptions.cityCountyPoster.filter : '',
    product: 'postings',
    output: 'subscriptionAudit'
  }

  const api = `external/companies/${companyId}/locations/export`

  return apiAsync({
    api,
    params,
    method: 'GET'
  })
}

export const patchLocation = async (locationId, patchData) => {
  const api = `/external/locations/${locationId}`

  const httpResult = await apiAsync({
    api,
    dataType: 'formPost',
    data: {
      callingLambda: 'customer-portal',
      locationsList: patchData
    },
    method: 'PATCH'
  })

  if (httpResult.status >= 400) {
    console.error('error making patchLocation request')
    throw new Error(httpResult.status, 'error making patchLocation request')
  }
}
